import React from 'react';

import API from 'utils/api';

import { PickerItemKind, PickerValue } from 'components/SharedFormComponents/UserAndGroupPicker';
import LicenceCoverageNotice, {
  LicenceNoticeSurface,
} from 'components/SharedFormComponents/UserAndGroupPicker/LicenceCoverageNotice';
import useGroupLicencePreview from 'components/SharedFormComponents/UserAndGroupPicker/useGroupLicencePreview';

const GroupLicenceNotice: React.FunctionComponent<{ value: PickerValue[] }> = ({ value }) => {
  const groups = value.filter((item) => item.kind === PickerItemKind.Group);
  const groupUuids = groups.map((group) => group.uuid);
  const groupKey = [...groupUuids].sort().join(',');

  const mountGroupKey = React.useRef(groupKey);
  const hasEditedGroups = React.useRef(false);
  if (groupKey !== mountGroupKey.current) hasEditedGroups.current = true;

  const preview = useGroupLicencePreview(
    groupUuids,
    async () => (await API.entities.previewAssignmentRuleTargetGroups({ targetGroups: groupUuids })()).data,
    { enabled: hasEditedGroups.current }
  );

  if (!preview) return null;

  return (
    <LicenceCoverageNotice
      surface={LicenceNoticeSurface.AssignmentRule}
      total={preview.total}
      licensed={preview.licensed}
      groupNames={groups.map((group) => group.name)}
    />
  );
};

export default GroupLicenceNotice;
